import { Dispatch } from 'react';
import { AuthActionType } from '../actionTypes';
import { User } from '../types';
import { AuthAction } from './auth';

export const updateCurrentUserTopicsWithUnreadMessages =
    (updatedUser: User) => async (dispatch: Dispatch<AuthAction>) => {
        dispatch({
            type: AuthActionType.UPDATE_CURRENT_USER_UNREAD_TOPIC_MESSAGES,
            payload: updatedUser,
        });
    };
